<template>
    <div>
        <div class="popup_epst13">
            <div class="popup_wrap">
                <div class="title"><span class="t02">{{ facNm }}</span></div>
                <div class="pop_bt_close"><a href="#" class="self-close-btn">닫기</a></div>
                <div class="pop_table03">
                    <table summary="시설 정보">
                        <caption>시설 정보</caption>
                        <colgroup>
                            <col>
                            <col>
                        </colgroup>
                        <tbody>
                            <tr v-for="col in displayfacCols" :key="col.dataKdHdngSqno">
                                <th scope="col">{{ col.scrnHdngnm }}</th>
                                <td scope="col">{{ facData[col.dataHdngColnm] }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FacilityInfoWin',
    data() {
        return {
            facData: undefined,
            facCols: undefined
        }
    },
    computed: {
        displayfacCols: function() {
            if(typeof this.facCols !== 'undefined') {
                return this.facCols.filter(function(facCol) {
                    return (facCol.scrnHdngnm != '' &&
                        facCol.dataHdngnm != 'LAT' &&
                        facCol.dataHdngnm != 'LONG' &&
                        facCol.scrnDispSq > 0);
                });
            }
        },
        facNm() {
            let facCols = this.facCols;

            if(typeof facCols !== 'undefined') {
                for(let i = 0; i < facCols.length; i++) {
                    if(facCols[i].dataHdngnm === 'FAC_NAME') {
                        return this.facData[facCols[i].dataHdngColnm];
                    }
                }
            }
        }
    },
    updated: function() {
        this.$emit('loaded-facility-info', this.$el.innerHTML);
    },
    methods: {
        setFacData: function(facData, facCols) {
            this.facData = Object.assign({}, facData);
            this.facCols = facCols;
        }
    }
}
</script>
